import styles from "./StudioAccessConfirmDialog.module.scss";
import { FormProvider } from "react-hook-form";
import { nameof } from "ts-simple-nameof";
import { AppDialog } from "../AppDialog/AppDialog";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import { DefaultTextareaField } from "../forms/inputs/textareaField/DefaultTextareaField";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";
import { IconType } from "../../icons/Icon";
import { useStudioAccessConfirmDialog } from "./hooks/useStudioAccessConfirmDialog";
import { IStudioAccessReasonFormModel } from "./models/studioAccessReasonFormModel";

export const StudioAccessConfirmDialog = () => {
  const {
    form,
    isVisible,
    dialogWidth,
    studioName,
    actorLabel,
    when,
    reasonPreview,
    isRecording,
    onConfirm,
    onConfirmHoldStart,
    onConfirmHoldEnd,
    onCancel,
  } = useStudioAccessConfirmDialog();

  return (
    <AppDialog
      header="Защитен достъп"
      headerIconType={IconType.Shield}
      visible={isVisible}
      onHide={onCancel}
      style={{ width: dialogWidth }}
      closable={!isRecording}
    >
      <FormProvider {...form}>
        <form className={styles.root} onSubmit={onConfirm}>
          <h2 className={styles.title}>
            Отваряте <span className={styles.title_studio}>„{studioName}“</span>
          </h2>
          <p className={styles.message}>
            Достъпът се записва в момента, в който потвърдите, и собственикът и мениджърите на
            обекта го виждат в профила си. Промените по настройките също се записват.
          </p>

          <DefaultTextareaField
            name={nameof<IStudioAccessReasonFormModel>((x) => x.reason)}
            label="Защо отваряте обекта?"
            placeholder="напр. Помощ с настройката на плащанията"
            rows={2}
            width="100%"
            className={styles.reason}
            required
          />

          <div className={styles.preview}>
            <span className={styles.preview_label}>Ще видят</span>
            <div className={styles.preview_row}>
              <span className={styles.preview_dot} aria-hidden />
              <div className={styles.preview_text}>
                <span className={styles.preview_actor}>{actorLabel}</span>
                <span className={styles.preview_meta}>
                  {studioName} · {when}
                </span>
                <RenderWhen condition={!!reasonPreview}>
                  <span className={styles.preview_reason}>{reasonPreview}</span>
                </RenderWhen>
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <DefaultButton
              className={styles.actions_button}
              label="Не"
              design="neutral"
              onClick={onCancel}
              disabled={isRecording}
            />
            <DefaultButton
              className={styles.actions_button}
              label="Да, отвори"
              design="accent"
              type="button"
              loading={isRecording}
              onClick={onConfirm}
              onPointerDown={onConfirmHoldStart}
              onPointerUp={onConfirmHoldEnd}
              onPointerLeave={onConfirmHoldEnd}
              onContextMenu={(event) => event.preventDefault()}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
